
import { useMemo } from 'react';
import * as Yup from 'yup';

export const useFormCadastrarPropagandaValidation = () => {

  const FormCadastrarPlanoValidationYup = useMemo(() => {
    return Yup.object().shape({
      descricao: Yup.string().required('Descrição é obrigatória'),
      tempoExibicao: Yup.number().required('Tempo de exibição é obrigatório').min(0, 'Tempo de Exibição deve ser maior ou igual a 0')
      ,
      tempoMinimo: Yup.number().nullable().min(0, 'Tempo mínimo deve ser maior ou igual a 0')
        .test('tempoMinimo', 'Tempo mínimo deve ser menor ou igual ao tempo de exibição', function (value) {
          if (!value) return true;
          const tempoExibicao = this.parent.tempoExibicao;
          return value <= tempoExibicao;
        }),
      dtInicial: Yup.string().required('Data Inicial é obrigatória'),
      dtFinal: Yup.string().required('Data final é obrigatória'),
      local: Yup.number().required('Local é obrigatório'),
      html: Yup.string().required('Conteúdo é obrigatório'),
      ignoraVisualizacao: Yup.boolean().nullable(),
    });
  }, [])

  return {
    FormCadastrarPlanoValidationYup,
  }
}

